import {GroupCelebration, Poll, Recognition} from "@irati/types"
import {RecognitionRoutes} from "../enums/Routes"

const getRecognitionPath = (recognition: Recognition) =>
  recognition && "uuid" in recognition ? `polls/recognition/${recognition.uuid}` : null

const getPollPath = (poll: Poll) => (poll && "uuid" in poll ? `polls/poll/${poll.uuid}` : null)

const getGroupCelebrationPath = (groupCelebration: GroupCelebration) => {
  if (location.pathname.includes(RecognitionRoutes.POLLS)) {
    return `${RecognitionRoutes.POLLS}/group-celebration/${groupCelebration.uuid}`
  }
  return `${RecognitionRoutes.ACCOUNT}/my-group-celebrations/${groupCelebration.uuid}`
}
export {getRecognitionPath, getPollPath, getGroupCelebrationPath}
